import { render, staticRenderFns } from "./DefaultNavbar.vue?vue&type=template&id=4ae50382"
import script from "./DefaultNavbar.vue?vue&type=script&lang=js"
export * from "./DefaultNavbar.vue?vue&type=script&lang=js"
import style0 from "./DefaultNavbar.vue?vue&type=style&index=0&id=4ae50382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports